import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ResolverService } from './___LOGIC/__common/resolver.service';
import { GuiFlowService } from './___LOGIC/__gui/gui-flow.service';
import { TranslationService } from './___LOGIC/__translate/translation.service';
import { AuthService } from './___LOGIC/__auth/auth.service';
import { SecurityLayerService } from './___LOGIC/__auth/security-layer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'voyjaleas-crm';

  isSidenavOpen = false;
  dashItems = [
/*     {
      section: 'To Do List',
      ref: 'todo-list',
      css: 'fa-solid fa-list-check',
      employee: true,
      admin: true
    }, */
    {
      section: 'Client Pipeline',
      ref: 'client-board',
      css: 'fa-solid fa-timeline',
      employee: true,
      admin: true
    },
    {
      section: 'Shopify Orders',
      ref: 'shopify-orders',
      css: 'fa-solid fa-timeline',
      employee: true,
      admin: true
    },
    {
      section: 'Order Simulator',
      ref: 'shopify-simulator',
      css: 'fa-solid fa-robot',
      employee: true,
      admin: true
    },
    {
      section: 'CRUD',
      ref: 'crud/userAppSession',
      css: 'fa fa-computer',
      employee: true,
      admin: true
    },
    {
      section: 'Calendly',
      ref: 'calendly-manager',
      css: 'fa-solid fa-videocall',
      employee: true,
      admin: true
    }/* ,
    {
      section: 'Accommodation',
      ref: 'finder',
      css: 'fa fa-house',
      employee: true,
      admin: true
    } */
  ];

  menuKbs = [
    {
      section: 'Knowledge Base',
      ref: 'kbs',
      css: 'fas fa-book',
      admin: true,
      employee: true
    },
    {
      section: 'Universities',
      ref: 'study-helper',
      css: 'fas fa-university',
      visible: false,
      admin: true,
      employee: true
    },
    {
      section: 'Visa',
      ref: 'pipeline-visa',
      css: 'fas fa-passport',
      visible: false,
      admin: true,
      employee: true
    }
  ];

  menuBudgets = [
    {
      section: 'Package & Plan Builder ',
      ref: 'package-builder',
      css: 'fas fa-cubes',
      admin: true,
      employee: true
    },
    {
      section: 'Budget Historic',
      ref: 'budget-manager',
      css: 'fas fa-cubes',
      admin: true,
      employee: true
    },
    {
      section: 'Create Budgets',
      ref: 'budget-builder',
      css: 'fas fa-cubes',
      admin: true,
      employee: true
    }
  ]; 

  menuCommunication = [
/*     {
      section: 'Inbox',
      ref: 'inbox',
      css: 'fas fa-envelope',
      admin: true,
      employee: true
    }, */
    {
      section: 'Email Composer',
      ref: 'email-composer',
      css: 'fas fa-envelope',
      admin: true,
      employee: true
    }
  ]; 

  webapp = [
    {
      section: 'Web App Users',
      ref: 'webapp-manager',
      css: 'fa fa-mobile-button',
      admin: true,
      employee: false
    },
  ];

  blog = [
    {
      section: 'Blog Manager',
      ref: 'blog-manager',
      css: 'fa fa-book',
      admin: true,
      employee: true
    }
  ];

  menuLandings = [
    {
      section: 'Estudiar',
      ref: '',
      css: 'fa fa-book',
      link: 'https://estudiar.voyjaleas.com',
      admin: true,
      employee: true
    },
    {
      section: 'Trabajo ',
      ref: 'new-email',
      css: 'fa fa-email',
      link: 'https://trabajar.voyjaleas.com',
      admin: true,
      employee: true
    },
    {
      section: 'Extranjería',
      ref: 'chats',
      css: 'fa fa-comment-dots',
      admin: true,
      employee: true
    },
    
  ]; 

  menuStudy = [
    {
      section: 'Study Helper',
      ref: 'study-helper',
      css: 'fa fa-book',
      admin: true,
      employee: true
    },
    {
      section: 'Visa Pipeline ',
      ref: 'visa-helper',
      css: 'fa fa-email',
      admin: true,
      employee: true
    }
    
  ]; 

  // Track the visibility of each section
  sections = {
    dashboard: true,
    library: false,
    communications: false,
    budgets: false,
    collaborations: false,
    webapp: false,
    study: false
  };

  collabs = [
    {
      section: 'Omnibus Clients',
      ref: 'om-dashboard',
      css: 'fa fa-laptop-medical',
      admin: true
    },
    {
      section: 'Bach Legal',
      ref: 'bach-legal-dashboard',
      css: 'fa-solid fa-scale-balanced',
      admin: true
    }
  ]
  
  constructor(private resolver: ResolverService,private router: Router,private translationService: TranslationService,private guiFlow: GuiFlowService,private securityLayer: SecurityLayerService,private auth: AuthService){
    //this.translationService.setDefaultLang();
    (window as any).__expireToken = () => this.auth.expireTokenForTest();
  }

  isSideNavVisible(){}
  
  isToolBarVisible(){
    let visible = true;
    this.router.url === '/login'? visible = false : null;
    return visible
  }

  getCssClass(menuItem){
    return menuItem.css +' sidemenu-icon menu-icon ';
  }

  getVisibleMenu(options){
    let res = [];
    let userRole = 'admin'; // TEMP
    for(let menuSection of options){
      /* this.securityLayer.getSessionData()? userRole = this.securityLayer.getSessionData().role : userRole = 'client'; */
      if(userRole == 'employee' && menuSection.employee){
        res.push(menuSection);
      }
      if(userRole == 'admin' && menuSection.admin){
        res.push(menuSection);
      }
    }
    return res;
  }

  goToPage(page,sidenav){
    sidenav.toggle();
    this.router.navigateByUrl(page);
  }

  goTo(page){
    this.router.navigateByUrl(page);
  }

  goToHome(){
/*     sidenav.toggle(); */
    this.router.navigateByUrl('home');
  }

  // Toggle function to show/hide a section
  toggleSection(section: string) {
    this.sections[section] = !this.sections[section];
  }

  closeSession(){

    this.securityLayer.registerCloseSession();
    this.router.navigateByUrl('login');
  }

}
